import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IconChevronDown } from "@tabler/icons-react";
import "../../css/sideNav.css";

const SideNav = ({ isOpen, setIsOpen, items }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("");
  const [openKeys, setOpenKeys] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // ✅ Detect mobile screen size dynamically
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Auto-highlight and Auto-expand based on URL
  useEffect(() => {
    const findKeysByPath = (items, path) => {
      for (let item of items) {
        // Check if current item is the one
        if (item.path === path) return { activeKey: item.key, parentKey: null };

        // Check children
        if (item.children) {
          for (let child of item.children) {
            if (child.path === path) return { activeKey: child.key, parentKey: item.key };
          }
        }
      }
      return { activeKey: null, parentKey: null };
    };

    const { activeKey, parentKey } = findKeysByPath(items, location.pathname);

    if (activeKey) setActiveKey(activeKey);
    if (parentKey) setOpenKeys({ [parentKey]: true });
  }, [location.pathname, items]);

  // ✅ Navigation + Auto-close on mobile
  const handleNavigation = (key, path, onClick) => {
    setActiveKey(key);
    if (onClick) onClick();
    if (path) navigate(path);
    if (isMobile) setIsOpen(false); // close sidenav on mobile
  };

  // ✅ Toggle submenu
  const toggleParent = (key) => {
    setOpenKeys((prev) => {
      if (prev[key]) return {};
      return { [key]: true };
    });
  };

  return (
    <div className="custom-sidenav">
      <div className={`sidenav ${isOpen ? "open" : ""}`}>
        <nav>
          {items.map((item) => {
            const isParentOpen = openKeys[item.key];

            return (
              <div key={item.key}>
                <div
                  className={`nav-item parent-item ${activeKey === item.key ? "active" : ""
                    } ${isParentOpen ? "open" : ""}`}
                  onClick={() =>
                    item.children
                      ? toggleParent(item.key)
                      : handleNavigation(item.key, item.path, item.onClick)
                  }
                >
                  {item.icon}
                  <span className="menu-label-text">{item.label}</span>
                  {item.children && (
                    <IconChevronDown
                      className="expansion-icon"
                      size={16}
                      stroke={2}
                    />
                  )}
                </div>

                {item.children && (
                  <div
                    className="submenu"
                    style={{
                      maxHeight: isParentOpen ? "1000px" : "0",
                      opacity: isParentOpen ? 1 : 0
                    }}
                  >
                    {item.children.map((child) => (
                      <div
                        key={child.key}
                        className={`nav-item submenu-item ${activeKey === child.key ? "active" : ""
                          }`}
                        onClick={() => handleNavigation(child.key, child.path, child.onClick)}
                      >
                        {child.icon}
                        <span className="menu-label-text">{child.label}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
      </div>
      {isMobile && isOpen && (
        <div className="sidenav-overlay" onClick={() => setIsOpen(false)} />
      )}
    </div>
  );
};

export default SideNav;
